import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import useFanPublicationStore from "%/stores/fan-publication-store";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import SmartFeedEngine from "SmartFeed/smart-feed-engine";

const MAX_TIMESTAMP = Number.MAX_SAFE_INTEGER;
export const useEventFeedStore = defineSmartFeedPiniaStore("event-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    tableFields: [
      {
        key: "title",
        label: "Title",
      },
      {
        key: "description",
        label: "Description",
      },
      {
        key: "eventTimestamp",
        label: "Event Date",
      },
      {
        key: "imageUrl",
        label: "Image",
      },
      {
        key: "status",
        label: "Status",
      },
      {
        key: "actions",
        label: "",
      },
    ],
    metadata: {
      lastId: 0,
      eventTimestampFrom: 0,
      eventTimestampTo: MAX_TIMESTAMP,
    },
  }),
  getters: {
    // Lazy read: a state snapshot froze publicationId at 0 pre-seed. The fan
    // store is only seeded on published pages — the creator dashboard's events
    // table shares this store, so fall back to the creator publication store.
    feedUrl() {
      const publicationId = useFanPublicationStore().publicationId
        || useCreatorPublicationStore().publicationId;
      return `events/publication/${publicationId}`;
    },
    smartFeedRequestGetParams() {
      const eventTimestampTo = this.metadata.eventTimestampTo ?? MAX_TIMESTAMP;
      return {
        last_id: this.metadata.lastId,
        event_timestamp_from: this.metadata.eventTimestampFrom,
        event_timestamp_to: Math.min(eventTimestampTo, MAX_TIMESTAMP),
      };
    },
  },
});
